import { Variant } from "@/components/Types";
import { smallerClosingCross } from "@/designSystemIcons";
import { cn } from "@/lib/utils";
import { useState } from "react";

import BaseDropdown, { BaseDropdownOption } from "../BaseDropdown";

interface MultiSelectDropdownProps {
  variant: Variant;
  defaultOption?: string;
  options: BaseDropdownOption[];
  selectedOptions: BaseDropdownOption[];
  onChange: (option: BaseDropdownOption) => void;
  handleClearAll: () => void;
}

const MultiSelectDropdown = ({
  variant,
  defaultOption,
  options,
  selectedOptions,
  onChange,
  handleClearAll,
}: MultiSelectDropdownProps) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="flex flex-row gap-x-1">
      <BaseDropdown
        label={defaultOption}
        open={open}
        setOpen={setOpen}
        variant={variant}
      >
        {options.map((option) => (
          <div
            className={cn(
              "flex items-center px-2 h-7 whitespace-nowrap cursor-pointer text-sm",
              selectedOptions.some(
                (selected) => selected.value === option.value,
              )
                ? "bg-tertiary-button-active"
                : "hover:bg-tertiary-button-hover",
            )}
            key={option.value}
            onClick={() => onChange(option)}
          >
            {option.label}
          </div>
        ))}
      </BaseDropdown>
      <button
        onClick={handleClearAll}
        className={cn(
          "px-2 flex-row gap-x-1 justify-center items-center bg-gray-700 rounded w-12",
          selectedOptions.length > 0 ? "flex" : "hidden",
        )}
      >
        <span className="text-sm">{selectedOptions.length}</span>
        <span className="fill-white/80">{smallerClosingCross}</span>
      </button>
    </div>
  );
};

export default MultiSelectDropdown;
